import { usePageContext } from '#app/hooks/usePageContext.js';
import { useEffect, useState } from 'react';

/**
 * Gives time of the last location change.
 * Used to bust cache of queries.
 *
 * Do not combine this with `useLocation` because
 * that would prevent efficient location memoization.
 */
export const useLastLocationTime = () => {
  const [time, setTime] = useState<number>(0);

  const pageContext = usePageContext();

  const { hashOriginal, pathname, searchOriginal } = pageContext.urlParsed;

  const key = [pathname, searchOriginal, hashOriginal].join('|');

  useEffect(() => {
    setTime(Date.now());
  }, [key]);

  return time;
};
